import { reactive } from "vue";
import { Observable } from "rxjs";

import Account from "@/helper/AccountHelper.js";
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import BzbsApi from "@/core/Http/BzbsApi";
import ConfigManager from "@/config/ConfigManager";

const obserInit = new Observable((subscriber) => {
    if (state.isInitial) {
        subscriber.next(state.isLogin);
    } else {
        subInitList.push(subscriber);
    }
});
const subInitList = [];

const state = reactive({
    isInitial: false,
    isLogin: false,
    profile: null,
    point: 0,
    userGrade: null
});

const methods = {
    init: function () {
        if (Account.isLogin()) {
            state.isLogin = true
            state.isInitial = true;
            this.getUserGrade()
            sendEventInit()
        } else {
            state.isLogin = false;
            state.isInitial = true;
        }
    },
    getProfile: function () {
        BzbsProfile.getProfile().subscribe({
            next: (data) => {
                
                state.profile = data.profile;
                state.point = data.profile.updated_points.points;

                sendEventInit();
            },
            error: (err) => {
                console.log(err);

                if (err.id == 412) {
                    Account.removeCacheUser();
                    window.location.reload();
                }
            },
        });
    },
    getUserGrade: function () {
        let url = ConfigManager.getApiModuleUrl() + "/user/grade"
        let token = Account.getToken()
        BzbsApi.connectBzbsGet(url, token, null).subscribe({
            next: (resp) => {
                console.log(resp.data)
                state.userGrade = resp.data?.requestId ?? null
            },
            error: () => {
                // do nothing
                state.userGrade = null
            }
        })
    },
    loginStatus: function () {
        return obserInit;
    },
    setProfile: function (profile) {
        state.profile = profile;
    },
    setUpdatePoint: function (point) {
        state.point = point;
    },
};

function sendEventInit() {
    for (let i of subInitList) {
        i.next(state.isLogin);
    }
}

export default {
    state: state,
    methods: methods,
};
